import Event from '../utils/event.js';

import DragObject from './drag-object.js';

class Pointer {
    constructor() {
        this.downEvent = new Event(); // parameters: { position: { x, y }, object }
        this.upEvent = new Event(); // parameters: { position: { x, y } }
        this.moveEvent = new Event(); // parameters: { position: { x, y } }
    }

    init() {}
    uninit() {}
    get position() { throw new Error('not implemented'); }
}

export default Pointer;
